import Storage from './Storage';

const PAGE_SIZE = "pageSize";
const itemsPerPageOptions = [20, 50, 100, 200];

const getValidPageSize = () => {
  let size = parseInt(Storage.getItem(PAGE_SIZE));
  if (!size || !itemsPerPageOptions.includes(size)) {
    size = itemsPerPageOptions[0];
    Storage.setItem(PAGE_SIZE, size);
  } 
  return size
}

const pageSize = (size) => {
  if (typeof size !== 'undefined') {
    Storage.setItem(PAGE_SIZE, size);
  } else {
    return getValidPageSize();
  }
}

export default pageSize;